import { ResolveFn } from '@angular/router';
import { Observable, tap, of, map } from 'rxjs';
import { inject } from '@angular/core';
import { OrganizationProvider, OrganizationProviderService } from 'riterz-core';

export const organizationProvidersResolver: ResolveFn<Observable<OrganizationProvider[]|null>> = (
  route, 
  state,
  organizationProviderService: OrganizationProviderService = inject(OrganizationProviderService),
) => {
  const organizationId = route.paramMap.get('organizationId');
  const params = {
    include: 'hasAudience,hasData,provider'
  }

  if (!organizationId) {
    return of(null);
  }

  return organizationProviderService
    .getPublicOrganizationProviders(organizationId, params)
    .pipe(
      map(response => response.data),
      tap({
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        error: () => {}
      })
    );
    
};
